const translations = {
  en: {
    // Loading
    loadingOpportunities: 'Loading opportunities...',

    // Header
    subtitle: 'EU Cross-Border Vehicle Arbitrage',
    live: 'LIVE',
    totalPotential: 'Total Potential',
    favourites: 'Favourites',

    // Welcome banner
    welcomeTitle: 'Welcome to Arbauto Beta',
    welcomeText1: 'Arbauto helps you find cross-border car arbitrage opportunities and savings. We are currently in',
    beta: 'beta',
    welcomeText2: ', presenting a selection of listings for',
    welcomeText3: 'sourced from Germany. We are adding new vehicles and countries on demand of the beta testers.',
    lastUpdate: 'Last update',
    welcomeFeedback: 'Have feedback, want a specific car listed, or a new source country? Let us know!',
    thanksFeedback: 'Thanks for your feedback!',
    emailPlaceholder: 'Email address',
    generalFeedbackPlaceholder: 'e.g. Add Audi A4 from France, general feedback, feature request...',
    sending: 'Sending...',
    send: 'Send',

    // Favourites banner
    viewingFavourites: 'Viewing {count} favourite{plural}',
    backToAll: 'Back to all opportunities',

    // Filters
    filters: 'Filters',
    sourceMarket: 'Source Market',
    allSources: 'All Sources',
    targetMarket: 'Target Market',
    make: 'Make',
    allMakes: 'All Makes',
    model: 'Model',
    allModels: 'All Models',
    selectMakeFirst: 'Select make first',
    versionTrim: 'Version/Trim',
    allVersions: 'All Versions',
    fuelType: 'Fuel Type',
    allFuelTypes: 'All Fuel Types',
    minProfit: 'Min. Profit',
    maxPrice: 'Max. Price',
    mileage: 'Mileage',
    year: 'Year',
    matchingCriteria: 'Matching Criteria',
    yearTolerance: 'Year Tolerance',
    mileageTolerance: 'Mileage Tolerance',
    sameYear: 'Same year',
    plusMinus1Year: '± 1 year',
    plusMinus2Years: '± 2 years',
    plusMinus3Years: '± 3 years',
    plusMinus5k: '± 5,000 km',
    plusMinus10k: '± 10,000 km',
    plusMinus20k: '± 20,000 km',
    plusMinus30k: '± 30,000 km',

    // Stats
    opportunities: 'Opportunities',
    avgProfit: 'Avg. Profit',
    avgProfitSaving: 'Avg. Profit/Saving',
    totalListings: 'Total Listings',

    // Sort
    sortBy: 'Sort by',
    netProfit: 'Net Profit',
    purchasePrice: 'Purchase Price',
    highToLow: 'High to Low',
    lowToHigh: 'Low to High',

    // Listing card
    profitSaving: 'profit/saving',
    similarIn: 'similar in',
    risk: 'RISK',

    // Expanded view
    costBreakdown: 'Cost Breakdown',
    purchasePriceCountry: 'Purchase Price ({country})',
    transport: 'Transport',
    importTax: 'Import Tax',
    registration: 'Registration',
    totalCost: 'Total Cost',
    costDisclaimer: 'Transport, import tax, and registration fees are estimates and may vary.',
    vehicleSpecs: 'Vehicle specs',

    revenueProjection: 'Revenue Projection',
    totalCosts: 'Total Costs',
    netProfitSaving: 'Net Profit/Saving',
    medianPriceInWithCount: 'Median Price in {country} ({count} listings)',
    aiQualityScoreTitle: 'AI Quality Score',
    qualityNotAvailable: 'Quality analysis not available for this listing.',
    qualityHigh: 'High',
    qualityMedium: 'Medium',
    qualityLow: 'Low',

    viewSourceListing: 'View Source Listing',
    somethingWrong: 'Something wrong? Let us know',
    reportIssue: 'Report an issue with this listing',
    reportPlaceholder: 'What seems wrong? (e.g. incorrect CO2, wrong price, duplicate listing...)',
    thanksReport: "Thanks for your feedback! We'll look into it.",

    // Empty states
    noFavourites: 'No favourites yet.',
    noFavouritesHint: 'Click the heart icon on any listing to save it here.',
    noOpportunities: 'No opportunities match your filters.',
    noOpportunitiesHint: 'Try adjusting your criteria or target market.',

    // Scroll / footer
    allLoaded: 'All {count} opportunities loaded',
    showingOf: 'Showing {visible} of {total}',
    loadMore: 'Load more opportunities',
    footerTagline: 'EU Cross-Border Vehicle Intelligence',

    // Tooltips
    backToTop: 'Back to top',
    addToFavourites: 'Add to favourites',
    removeFromFavourites: 'Remove from favourites',

    // Login / Beta access
    loginTagline: 'EU Cross-Border Vehicle Arbitrage Platform',
    loginTitle: 'Beta Access',
    accessCodeLabel: 'Access Code',
    accessCodePlaceholder: 'Enter your access code',
    loginButton: 'Access Platform',
    validating: 'Validating...',
    loginFooter: 'Access restricted to authorized beta users. Contact hello@arbauto.eu for access.',
    logout: 'Logout',

    // Cookie consent
    cookieTitle: 'We value your privacy',
    cookieText: 'We use cookies to improve your experience and analyse site usage. No advertising cookies.',
    cookieAccept: 'Accept',
    cookieDecline: 'Decline',

    // Legal
    privacyPolicy: 'Privacy Policy',
    termsConditions: 'Terms & Conditions',
    close: 'Close',

    privacyContent: `Last updated: February 2026

1. Data Controller
Arbauto is operated by Ixmat Limited (Company number 10611013), registered at 1053 London Road, Leigh-On-Sea, Essex, England, SS9 3JP. For data inquiries, contact hello@arbauto.eu.

2. Data We Collect
- Feedback form submissions (email address, message text)
- Anonymous usage analytics (page views, clicks, session recordings) via Microsoft Clarity and PostHog — only with your consent
- Language preference (stored locally in your browser)
- Favourites (stored locally in your browser)

3. How We Use Your Data
- Feedback emails: to respond to your inquiries and improve our service
- Analytics: to understand how users interact with the platform and improve the experience

4. Data Storage & Processors
- Database: Supabase (EU region)
- Hosting: Vercel
- Email: Resend
- Analytics: Microsoft Clarity, PostHog (only with consent)

5. Your Rights Under GDPR
You have the right to access, rectify, delete, or export your personal data. Contact hello@arbauto.eu for any data requests. We will respond within 30 days.

6. Cookies
We only use analytics cookies, and only after you give explicit consent. No advertising or tracking cookies are used. You can change your preference at any time by clearing your browser's local storage.

7. Data Retention
Feedback data is retained for up to 2 years. Analytics data follows the retention policies of our analytics providers.`,

    termsContent: `Last updated: February 2026

1. Service Description
Arbauto is a vehicle price comparison and intelligence platform currently in beta, operated by Ixmat Limited (Company number 10611013), registered at 1053 London Road, Leigh-On-Sea, Essex, England, SS9 3JP. We aggregate publicly available car listing data from third-party websites to help users identify cross-border price differences within the EU.

2. Estimates Disclaimer
All costs displayed on this platform — including but not limited to transport costs, import taxes, registration fees, and net profit/saving calculations — are ESTIMATES ONLY and may vary significantly from actual costs. Arbauto does not guarantee the accuracy of any calculation.

3. No Financial or Legal Advice
Arbauto does not provide financial, legal, or professional advice. Any decisions made based on information provided by this platform are at the user's sole risk and responsibility.

4. Third-Party Data
Vehicle listings are sourced from publicly available third-party platforms. Arbauto is not affiliated with any source platform. We do not guarantee the availability, accuracy, or timeliness of any listing.

5. No Warranty
This service is provided "as is" and "as available" without warranties of any kind. We make no guarantees about the completeness, reliability, or accuracy of the information.

6. Limitation of Liability
Arbauto shall not be liable for any direct, indirect, incidental, or consequential damages arising from the use of this platform or reliance on any information provided.

7. Beta Status
This platform is currently in beta. Features may change, be removed, or malfunction without notice.

8. Contact
For questions about these terms, contact hello@arbauto.eu.`,
  },

  pt: {
    loadingOpportunities: 'A carregar oportunidades...',

    subtitle: 'Arbitragem de Veículos Transfronteiriça na UE',
    live: 'AO VIVO',
    totalPotential: 'Potencial Total',
    favourites: 'Favoritos',

    welcomeTitle: 'Bem-vindo ao Arbauto Beta',
    welcomeText1: 'O Arbauto ajuda-o a encontrar oportunidades de arbitragem e poupança em veículos transfronteiriços. Estamos atualmente em',
    beta: 'beta',
    welcomeText2: ', apresentando uma seleção de anúncios de',
    welcomeText3: 'provenientes da Alemanha. Estamos a adicionar novos veículos e países a pedido dos testadores beta.',
    lastUpdate: 'Última atualização',
    welcomeFeedback: 'Tem feedback, quer um carro específico listado ou um novo país de origem? Diga-nos!',
    thanksFeedback: 'Obrigado pelo seu feedback!',
    emailPlaceholder: 'Endereço de email',
    generalFeedbackPlaceholder: 'Ex: Adicionar Audi A4 de França, feedback geral, pedido de funcionalidade...',
    sending: 'A enviar...',
    send: 'Enviar',

    viewingFavourites: 'A ver {count} favorito{plural}',
    backToAll: 'Voltar a todas as oportunidades',

    filters: 'Filtros',
    sourceMarket: 'Mercado de Origem',
    allSources: 'Todas as Origens',
    targetMarket: 'Mercado de Destino',
    make: 'Marca',
    allMakes: 'Todas as Marcas',
    model: 'Modelo',
    allModels: 'Todos os Modelos',
    selectMakeFirst: 'Selecione a marca primeiro',
    versionTrim: 'Versão/Acabamento',
    allVersions: 'Todas as Versões',
    fuelType: 'Combustível',
    allFuelTypes: 'Todos os Combustíveis',
    minProfit: 'Lucro Mín.',
    maxPrice: 'Preço Máx.',
    mileage: 'Quilometragem',
    year: 'Ano',
    matchingCriteria: 'Critérios de Correspondência',
    yearTolerance: 'Tolerância do Ano',
    mileageTolerance: 'Tolerância da Quilometragem',
    sameYear: 'Mesmo ano',
    plusMinus1Year: '± 1 ano',
    plusMinus2Years: '± 2 anos',
    plusMinus3Years: '± 3 anos',
    plusMinus5k: '± 5.000 km',
    plusMinus10k: '± 10.000 km',
    plusMinus20k: '± 20.000 km',
    plusMinus30k: '± 30.000 km',

    opportunities: 'Oportunidades',
    avgProfit: 'Lucro Médio',
    avgProfitSaving: 'Lucro/Poupança Média',
    totalListings: 'Total de Anúncios',

    sortBy: 'Ordenar por',
    netProfit: 'Lucro Líquido',
    purchasePrice: 'Preço de Compra',
    highToLow: 'Maior para Menor',
    lowToHigh: 'Menor para Maior',

    profitSaving: 'lucro/poupança',
    similarIn: 'semelhantes em',
    risk: 'RISCO',

    costBreakdown: 'Detalhe dos Custos',
    purchasePriceCountry: 'Preço de Compra ({country})',
    transport: 'Transporte',
    importTax: 'Imposto de Importação',
    registration: 'Registo',
    totalCost: 'Custo Total',
    costDisclaimer: 'Transporte, imposto de importação e taxas de registo são estimativas e podem variar.',
    vehicleSpecs: 'Especificações do veículo',

    revenueProjection: 'Projeção de Receita',
    totalCosts: 'Custos Totais',
    netProfitSaving: 'Lucro/Poupança Líquido',
    medianPriceInWithCount: 'Preço Mediano em {country} ({count} anúncios)',
    aiQualityScoreTitle: 'Pontuação de Qualidade IA',
    qualityNotAvailable: 'Análise de qualidade não disponível para este anúncio.',
    qualityHigh: 'Alto',
    qualityMedium: 'Médio',
    qualityLow: 'Baixo',

    viewSourceListing: 'Ver Anúncio Original',
    somethingWrong: 'Algo errado? Diga-nos',
    reportIssue: 'Reportar um problema com este anúncio',
    reportPlaceholder: 'O que parece errado? (Ex: CO2 incorreto, preço errado, anúncio duplicado...)',
    thanksReport: 'Obrigado pelo seu feedback! Vamos analisar.',

    noFavourites: 'Sem favoritos ainda.',
    noFavouritesHint: 'Clique no ícone de coração em qualquer anúncio para guardá-lo aqui.',
    noOpportunities: 'Nenhuma oportunidade corresponde aos seus filtros.',
    noOpportunitiesHint: 'Tente ajustar os seus critérios ou mercado de destino.',

    allLoaded: 'Todas as {count} oportunidades carregadas',
    showingOf: 'A mostrar {visible} de {total}',
    loadMore: 'Carregar mais oportunidades',
    footerTagline: 'Inteligência de Veículos Transfronteiriça na UE',

    backToTop: 'Voltar ao topo',
    addToFavourites: 'Adicionar aos favoritos',
    removeFromFavourites: 'Remover dos favoritos',

    loginTagline: 'Plataforma de Arbitragem de Veículos Transfronteiriça na UE',
    loginTitle: 'Acesso Beta',
    accessCodeLabel: 'Código de Acesso',
    accessCodePlaceholder: 'Digite o seu código de acesso',
    loginButton: 'Acessar Plataforma',
    validating: 'A validar...',
    loginFooter: 'Acesso restrito a utilizadores beta autorizados. Contacte hello@arbauto.eu para acesso.',
    logout: 'Sair',

    cookieTitle: 'Valorizamos a sua privacidade',
    cookieText: 'Utilizamos cookies para melhorar a sua experiência e analisar o uso do site. Sem cookies publicitários.',
    cookieAccept: 'Aceitar',
    cookieDecline: 'Recusar',

    privacyPolicy: 'Política de Privacidade',
    termsConditions: 'Termos e Condições',
    close: 'Fechar',

    privacyContent: `Última atualização: Fevereiro 2026

1. Responsável pelo Tratamento
A Arbauto é operada pela Ixmat Limited (número de empresa 10611013), registada em 1053 London Road, Leigh-On-Sea, Essex, Inglaterra, SS9 3JP. Para questões sobre dados, contacte hello@arbauto.eu.

2. Dados que Recolhemos
- Submissões de formulários de feedback (endereço de email, texto da mensagem)
- Análise anónima de utilização (visualizações de página, cliques, gravações de sessão) via Microsoft Clarity e PostHog — apenas com o seu consentimento
- Preferência de idioma (armazenada localmente no seu navegador)
- Favoritos (armazenados localmente no seu navegador)

3. Como Utilizamos os Seus Dados
- Emails de feedback: para responder às suas questões e melhorar o nosso serviço
- Análise: para compreender como os utilizadores interagem com a plataforma e melhorar a experiência

4. Armazenamento de Dados e Subcontratantes
- Base de dados: Supabase (região UE)
- Alojamento: Vercel
- Email: Resend
- Análise: Microsoft Clarity, PostHog (apenas com consentimento)

5. Os Seus Direitos ao Abrigo do RGPD
Tem o direito de aceder, retificar, eliminar ou exportar os seus dados pessoais. Contacte hello@arbauto.eu para qualquer pedido. Responderemos no prazo de 30 dias.

6. Cookies
Utilizamos apenas cookies de análise, e apenas após o seu consentimento explícito. Não são utilizados cookies publicitários ou de rastreamento. Pode alterar a sua preferência a qualquer momento limpando o armazenamento local do seu navegador.

7. Retenção de Dados
Os dados de feedback são retidos até 2 anos. Os dados de análise seguem as políticas de retenção dos nossos fornecedores.`,

    termsContent: `Última atualização: Fevereiro 2026

1. Descrição do Serviço
A Arbauto é uma plataforma de comparação de preços e inteligência automóvel atualmente em fase beta, operada pela Ixmat Limited (número de empresa 10611013), registada em 1053 London Road, Leigh-On-Sea, Essex, Inglaterra, SS9 3JP. Agregamos dados de anúncios de automóveis publicamente disponíveis de sites de terceiros para ajudar os utilizadores a identificar diferenças de preço transfronteiriças na UE.

2. Aviso sobre Estimativas
Todos os custos apresentados nesta plataforma — incluindo mas não limitado a custos de transporte, impostos de importação, taxas de registo e cálculos de lucro/poupança líquidos — são APENAS ESTIMATIVAS e podem variar significativamente dos custos reais. A Arbauto não garante a precisão de qualquer cálculo.

3. Sem Aconselhamento Financeiro ou Jurídico
A Arbauto não fornece aconselhamento financeiro, jurídico ou profissional. Quaisquer decisões tomadas com base em informações fornecidas por esta plataforma são da responsabilidade exclusiva do utilizador.

4. Dados de Terceiros
Os anúncios de veículos provêm de plataformas de terceiros publicamente acessíveis. A Arbauto não é afiliada a nenhuma plataforma de origem. Não garantimos a disponibilidade, precisão ou atualidade de qualquer anúncio.

5. Sem Garantia
Este serviço é fornecido "tal como está" e "conforme disponível" sem garantias de qualquer tipo.

6. Limitação de Responsabilidade
A Arbauto não será responsável por quaisquer danos diretos, indiretos, incidentais ou consequenciais decorrentes da utilização desta plataforma.

7. Estado Beta
Esta plataforma encontra-se atualmente em fase beta. As funcionalidades podem ser alteradas, removidas ou apresentar falhas sem aviso prévio.

8. Contacto
Para questões sobre estes termos, contacte hello@arbauto.eu.`,
  },

  fr: {
    loadingOpportunities: 'Chargement des opportunités...',

    subtitle: "Arbitrage de Véhicules Transfrontalier dans l'UE",
    live: 'EN DIRECT',
    totalPotential: 'Potentiel Total',
    favourites: 'Favoris',

    welcomeTitle: 'Bienvenue sur Arbauto Beta',
    welcomeText1: "Arbauto vous aide à trouver des opportunités d'arbitrage et d'économies sur les véhicules transfrontaliers. Nous sommes actuellement en",
    beta: 'bêta',
    welcomeText2: ', présentant une sélection d\u2019annonces pour',
    welcomeText3: "en provenance d'Allemagne. Nous ajoutons de nouveaux véhicules et pays à la demande des testeurs bêta.",
    lastUpdate: 'Dernière mise à jour',
    welcomeFeedback: "Des commentaires, un véhicule spécifique souhaité ou un nouveau pays d'origine ? Dites-le nous !",
    thanksFeedback: 'Merci pour votre retour !',
    emailPlaceholder: 'Adresse email',
    generalFeedbackPlaceholder: 'Ex : Ajouter Audi A4 de France, commentaire général, demande de fonctionnalité...',
    sending: 'Envoi en cours...',
    send: 'Envoyer',

    viewingFavourites: 'Affichage de {count} favori{plural}',
    backToAll: 'Retour à toutes les opportunités',

    filters: 'Filtres',
    sourceMarket: 'Marché Source',
    allSources: 'Toutes les Sources',
    targetMarket: 'Marché Cible',
    make: 'Marque',
    allMakes: 'Toutes les Marques',
    model: 'Modèle',
    allModels: 'Tous les Modèles',
    selectMakeFirst: "Sélectionnez d'abord la marque",
    versionTrim: 'Version/Finition',
    allVersions: 'Toutes les Versions',
    fuelType: 'Carburant',
    allFuelTypes: 'Tous les Carburants',
    minProfit: 'Profit Min.',
    maxPrice: 'Prix Max.',
    mileage: 'Kilométrage',
    year: 'Année',
    matchingCriteria: 'Critères de Correspondance',
    yearTolerance: "Tolérance d'Année",
    mileageTolerance: 'Tolérance du Kilométrage',
    sameYear: 'Même année',
    plusMinus1Year: '± 1 an',
    plusMinus2Years: '± 2 ans',
    plusMinus3Years: '± 3 ans',
    plusMinus5k: '± 5 000 km',
    plusMinus10k: '± 10 000 km',
    plusMinus20k: '± 20 000 km',
    plusMinus30k: '± 30 000 km',

    opportunities: 'Opportunités',
    avgProfit: 'Profit Moyen',
    avgProfitSaving: 'Profit/Économie Moyen',
    totalListings: 'Total des Annonces',

    sortBy: 'Trier par',
    netProfit: 'Profit Net',
    purchasePrice: "Prix d'Achat",
    highToLow: 'Du Plus au Moins',
    lowToHigh: 'Du Moins au Plus',

    profitSaving: 'profit/économie',
    similarIn: 'similaires en',
    risk: 'RISQUE',

    costBreakdown: 'Détail des Coûts',
    purchasePriceCountry: "Prix d'Achat ({country})",
    transport: 'Transport',
    importTax: "Taxe d'Importation",
    registration: 'Immatriculation',
    totalCost: 'Coût Total',
    costDisclaimer: "Transport, taxe d'importation et frais d'immatriculation sont des estimations et peuvent varier.",
    vehicleSpecs: 'Spécifications du véhicule',

    revenueProjection: 'Projection de Revenus',
    totalCosts: 'Coûts Totaux',
    netProfitSaving: 'Profit/Économie Net',
    medianPriceInWithCount: 'Prix Médian en {country} ({count} annonces)',
    aiQualityScoreTitle: 'Score de Qualité IA',
    qualityNotAvailable: 'Analyse de qualité non disponible pour cette annonce.',
    qualityHigh: 'Haut',
    qualityMedium: 'Moyen',
    qualityLow: 'Bas',

    viewSourceListing: "Voir l'Annonce Source",
    somethingWrong: "Quelque chose d'incorrect ? Dites-le nous",
    reportIssue: 'Signaler un problème avec cette annonce',
    reportPlaceholder: 'Que semble incorrect ? (Ex : CO2 incorrect, mauvais prix, annonce en double...)',
    thanksReport: 'Merci pour votre retour ! Nous allons vérifier.',

    noFavourites: "Aucun favori pour l'instant.",
    noFavouritesHint: "Cliquez sur l'icône cœur sur n'importe quelle annonce pour la sauvegarder ici.",
    noOpportunities: 'Aucune opportunité ne correspond à vos filtres.',
    noOpportunitiesHint: "Essayez d'ajuster vos critères ou le marché cible.",

    allLoaded: 'Les {count} opportunités sont chargées',
    showingOf: 'Affichage de {visible} sur {total}',
    loadMore: "Charger plus d'opportunités",
    footerTagline: "Intelligence Véhicule Transfrontalière dans l'UE",

    backToTop: 'Retour en haut',
    addToFavourites: 'Ajouter aux favoris',
    removeFromFavourites: 'Retirer des favoris',

    loginTagline: "Plateforme d'Arbitrage de Véhicules Transfrontalier dans l'UE",
    loginTitle: 'Accès Bêta',
    accessCodeLabel: "Code d'Accès",
    accessCodePlaceholder: "Entrez votre code d'accès",
    loginButton: 'Accéder à la Plateforme',
    validating: 'Validation en cours...',
    loginFooter: 'Accès réservé aux utilisateurs bêta autorisés. Contactez hello@arbauto.eu pour y accéder.',
    logout: 'Déconnexion',

    cookieTitle: 'Nous respectons votre vie privée',
    cookieText: "Nous utilisons des cookies pour améliorer votre expérience et analyser l'utilisation du site. Aucun cookie publicitaire.",
    cookieAccept: 'Accepter',
    cookieDecline: 'Refuser',

    privacyPolicy: 'Politique de Confidentialité',
    termsConditions: 'Conditions Générales',
    close: 'Fermer',

    privacyContent: `Dernière mise à jour : Février 2026

1. Responsable du Traitement
Arbauto est opéré par Ixmat Limited (numéro d'entreprise 10611013), enregistrée au 1053 London Road, Leigh-On-Sea, Essex, Angleterre, SS9 3JP. Pour toute question relative aux données, contactez hello@arbauto.eu.

2. Données que Nous Collectons
- Soumissions de formulaires de feedback (adresse email, texte du message)
- Analyse anonyme d'utilisation (pages vues, clics, enregistrements de session) via Microsoft Clarity et PostHog — uniquement avec votre consentement
- Préférence de langue (stockée localement dans votre navigateur)
- Favoris (stockés localement dans votre navigateur)

3. Comment Nous Utilisons Vos Données
- Emails de feedback : pour répondre à vos questions et améliorer notre service
- Analyse : pour comprendre comment les utilisateurs interagissent avec la plateforme et améliorer l'expérience

4. Stockage des Données et Sous-traitants
- Base de données : Supabase (région UE)
- Hébergement : Vercel
- Email : Resend
- Analyse : Microsoft Clarity, PostHog (uniquement avec consentement)

5. Vos Droits en vertu du RGPD
Vous avez le droit d'accéder, de rectifier, de supprimer ou d'exporter vos données personnelles. Contactez hello@arbauto.eu pour toute demande. Nous répondrons dans un délai de 30 jours.

6. Cookies
Nous n'utilisons que des cookies d'analyse, et uniquement après votre consentement explicite. Aucun cookie publicitaire ou de suivi n'est utilisé. Vous pouvez modifier votre préférence à tout moment en effaçant le stockage local de votre navigateur.

7. Conservation des Données
Les données de feedback sont conservées jusqu'à 2 ans. Les données d'analyse suivent les politiques de conservation de nos fournisseurs.`,

    termsContent: `Dernière mise à jour : Février 2026

1. Description du Service
Arbauto est une plateforme de comparaison de prix et d'intelligence véhicule actuellement en phase bêta, opérée par Ixmat Limited (numéro d'entreprise 10611013), enregistrée au 1053 London Road, Leigh-On-Sea, Essex, Angleterre, SS9 3JP. Nous agrégeons des données d'annonces automobiles accessibles publiquement depuis des sites tiers pour aider les utilisateurs à identifier les différences de prix transfrontaliers au sein de l'UE.

2. Avertissement sur les Estimations
Tous les coûts affichés sur cette plateforme — y compris mais sans s'y limiter les coûts de transport, taxes d'importation, frais d'immatriculation et calculs de profit/économie nets — sont UNIQUEMENT DES ESTIMATIONS et peuvent varier significativement par rapport aux coûts réels. Arbauto ne garantit l'exactitude d'aucun calcul.

3. Pas de Conseil Financier ou Juridique
Arbauto ne fournit aucun conseil financier, juridique ou professionnel. Toute décision prise sur la base des informations fournies par cette plateforme relève de la seule responsabilité de l'utilisateur.

4. Données de Tiers
Les annonces de véhicules proviennent de plateformes tierces accessibles publiquement. Arbauto n'est affilié à aucune plateforme source. Nous ne garantissons pas la disponibilité, l'exactitude ou l'actualité d'aucune annonce.

5. Aucune Garantie
Ce service est fourni « tel quel » et « selon disponibilité » sans garantie d'aucune sorte.

6. Limitation de Responsabilité
Arbauto ne saurait être tenu responsable de tout dommage direct, indirect, accessoire ou consécutif résultant de l'utilisation de cette plateforme.

7. Statut Bêta
Cette plateforme est actuellement en phase bêta. Les fonctionnalités peuvent être modifiées, supprimées ou dysfonctionner sans préavis.

8. Contact
Pour toute question relative à ces conditions, contactez hello@arbauto.eu.`,
  },

  es: {
    loadingOpportunities: 'Cargando oportunidades...',

    subtitle: 'Arbitraje de Vehículos Transfronterizo en la UE',
    live: 'EN VIVO',
    totalPotential: 'Potencial Total',
    favourites: 'Favoritos',

    welcomeTitle: 'Bienvenido a Arbauto Beta',
    welcomeText1: 'Arbauto te ayuda a encontrar oportunidades de arbitraje y ahorro en vehículos transfronterizos. Actualmente estamos en',
    beta: 'beta',
    welcomeText2: ', presentando una selección de anuncios de',
    welcomeText3: 'procedentes de Alemania. Estamos añadiendo nuevos vehículos y países a petición de los testers beta.',
    lastUpdate: 'Última actualización',
    welcomeFeedback: '¿Tienes comentarios, quieres un coche específico o un nuevo país de origen? ¡Dínoslo!',
    thanksFeedback: '¡Gracias por tu comentario!',
    emailPlaceholder: 'Dirección de email',
    generalFeedbackPlaceholder: 'Ej: Añadir Audi A4 de Francia, comentario general, solicitud de función...',
    sending: 'Enviando...',
    send: 'Enviar',

    viewingFavourites: 'Viendo {count} favorito{plural}',
    backToAll: 'Volver a todas las oportunidades',

    filters: 'Filtros',
    sourceMarket: 'Mercado de Origen',
    allSources: 'Todos los Orígenes',
    targetMarket: 'Mercado de Destino',
    make: 'Marca',
    allMakes: 'Todas las Marcas',
    model: 'Modelo',
    allModels: 'Todos los Modelos',
    selectMakeFirst: 'Selecciona marca primero',
    versionTrim: 'Versión/Acabado',
    allVersions: 'Todas las Versiones',
    fuelType: 'Combustible',
    allFuelTypes: 'Todos los Combustibles',
    minProfit: 'Beneficio Mín.',
    maxPrice: 'Precio Máx.',
    mileage: 'Kilometraje',
    year: 'Año',
    matchingCriteria: 'Criterios de Coincidencia',
    yearTolerance: 'Tolerancia del Año',
    mileageTolerance: 'Tolerancia del Kilometraje',
    sameYear: 'Mismo año',
    plusMinus1Year: '± 1 año',
    plusMinus2Years: '± 2 años',
    plusMinus3Years: '± 3 años',
    plusMinus5k: '± 5.000 km',
    plusMinus10k: '± 10.000 km',
    plusMinus20k: '± 20.000 km',
    plusMinus30k: '± 30.000 km',

    opportunities: 'Oportunidades',
    avgProfit: 'Beneficio Medio',
    avgProfitSaving: 'Beneficio/Ahorro Medio',
    totalListings: 'Total de Anuncios',

    sortBy: 'Ordenar por',
    netProfit: 'Beneficio Neto',
    purchasePrice: 'Precio de Compra',
    highToLow: 'Mayor a Menor',
    lowToHigh: 'Menor a Mayor',

    profitSaving: 'beneficio/ahorro',
    similarIn: 'similares en',
    risk: 'RIESGO',

    costBreakdown: 'Desglose de Costes',
    purchasePriceCountry: 'Precio de Compra ({country})',
    transport: 'Transporte',
    importTax: 'Impuesto de Importación',
    registration: 'Matriculación',
    totalCost: 'Coste Total',
    costDisclaimer: 'Transporte, impuesto de importación y tasas de matriculación son estimaciones y pueden variar.',
    vehicleSpecs: 'Especificaciones del vehículo',

    revenueProjection: 'Proyección de Ingresos',
    totalCosts: 'Costes Totales',
    netProfitSaving: 'Beneficio/Ahorro Neto',
    medianPriceInWithCount: 'Precio Mediano en {country} ({count} anuncios)',
    aiQualityScoreTitle: 'Puntuación de Calidad IA',
    qualityNotAvailable: 'Análisis de calidad no disponible para este anuncio.',
    qualityHigh: 'Alto',
    qualityMedium: 'Medio',
    qualityLow: 'Bajo',

    viewSourceListing: 'Ver Anuncio Original',
    somethingWrong: '¿Algo incorrecto? Dínoslo',
    reportIssue: 'Reportar un problema con este anuncio',
    reportPlaceholder: '¿Qué parece incorrecto? (Ej: CO2 incorrecto, precio erróneo, anuncio duplicado...)',
    thanksReport: '¡Gracias por tu comentario! Lo revisaremos.',

    noFavourites: 'Sin favoritos todavía.',
    noFavouritesHint: 'Haz clic en el icono de corazón en cualquier anuncio para guardarlo aquí.',
    noOpportunities: 'Ninguna oportunidad coincide con tus filtros.',
    noOpportunitiesHint: 'Intenta ajustar tus criterios o mercado de destino.',

    allLoaded: 'Todas las {count} oportunidades cargadas',
    showingOf: 'Mostrando {visible} de {total}',
    loadMore: 'Cargar más oportunidades',
    footerTagline: 'Inteligencia de Vehículos Transfronteriza en la UE',

    backToTop: 'Volver arriba',
    addToFavourites: 'Añadir a favoritos',
    removeFromFavourites: 'Eliminar de favoritos',

    loginTagline: 'Plataforma de Arbitraje de Vehículos Transfronterizo en la UE',
    loginTitle: 'Acceso Beta',
    accessCodeLabel: 'Código de Acceso',
    accessCodePlaceholder: 'Ingrese su código de acceso',
    loginButton: 'Acceder a la Plataforma',
    validating: 'Validando...',
    loginFooter: 'Acceso restringido a usuarios beta autorizados. Contacte hello@arbauto.eu para acceso.',
    logout: 'Cerrar sesión',

    cookieTitle: 'Valoramos tu privacidad',
    cookieText: 'Usamos cookies para mejorar tu experiencia y analizar el uso del sitio. Sin cookies publicitarias.',
    cookieAccept: 'Aceptar',
    cookieDecline: 'Rechazar',

    privacyPolicy: 'Política de Privacidad',
    termsConditions: 'Términos y Condiciones',
    close: 'Cerrar',

    privacyContent: `Última actualización: Febrero 2026

1. Responsable del Tratamiento
Arbauto es operada por Ixmat Limited (número de empresa 10611013), registrada en 1053 London Road, Leigh-On-Sea, Essex, Inglaterra, SS9 3JP. Para consultas sobre datos, contacta con hello@arbauto.eu.

2. Datos que Recopilamos
- Envíos de formularios de feedback (dirección de email, texto del mensaje)
- Analítica anónima de uso (páginas vistas, clics, grabaciones de sesión) via Microsoft Clarity y PostHog — solo con tu consentimiento
- Preferencia de idioma (almacenada localmente en tu navegador)
- Favoritos (almacenados localmente en tu navegador)

3. Cómo Usamos tus Datos
- Emails de feedback: para responder a tus consultas y mejorar nuestro servicio
- Analítica: para entender cómo los usuarios interactúan con la plataforma y mejorar la experiencia

4. Almacenamiento de Datos y Procesadores
- Base de datos: Supabase (región UE)
- Alojamiento: Vercel
- Email: Resend
- Analítica: Microsoft Clarity, PostHog (solo con consentimiento)

5. Tus Derechos bajo el RGPD
Tienes derecho a acceder, rectificar, eliminar o exportar tus datos personales. Contacta con hello@arbauto.eu para cualquier solicitud. Responderemos en un plazo de 30 días.

6. Cookies
Solo usamos cookies de analítica, y solo después de tu consentimiento explícito. No se utilizan cookies publicitarias ni de seguimiento. Puedes cambiar tu preferencia en cualquier momento borrando el almacenamiento local de tu navegador.

7. Retención de Datos
Los datos de feedback se conservan hasta 2 años. Los datos de analítica siguen las políticas de retención de nuestros proveedores.`,

    termsContent: `Última actualización: Febrero 2026

1. Descripción del Servicio
Arbauto es una plataforma de comparación de precios e inteligencia de vehículos actualmente en fase beta, operada por Ixmat Limited (número de empresa 10611013), registrada en 1053 London Road, Leigh-On-Sea, Essex, Inglaterra, SS9 3JP. Agregamos datos de anuncios de coches disponibles públicamente de sitios web de terceros para ayudar a los usuarios a identificar diferencias de precios transfronterizas en la UE.

2. Aviso sobre Estimaciones
Todos los costes mostrados en esta plataforma — incluidos pero no limitados a costes de transporte, impuestos de importación, tasas de matriculación y cálculos de beneficio/ahorro neto — son SOLO ESTIMACIONES y pueden variar significativamente de los costes reales. Arbauto no garantiza la precisión de ningún cálculo.

3. Sin Asesoramiento Financiero o Legal
Arbauto no proporciona asesoramiento financiero, legal o profesional. Cualquier decisión tomada basándose en la información proporcionada por esta plataforma es responsabilidad exclusiva del usuario.

4. Datos de Terceros
Los anuncios de vehículos provienen de plataformas de terceros disponibles públicamente. Arbauto no está afiliada a ninguna plataforma de origen. No garantizamos la disponibilidad, precisión o actualidad de ningún anuncio.

5. Sin Garantía
Este servicio se proporciona "tal cual" y "según disponibilidad" sin garantías de ningún tipo.

6. Limitación de Responsabilidad
Arbauto no será responsable de ningún daño directo, indirecto, incidental o consecuente derivado del uso de esta plataforma.

7. Estado Beta
Esta plataforma se encuentra actualmente en fase beta. Las funcionalidades pueden cambiar, eliminarse o funcionar incorrectamente sin previo aviso.

8. Contacto
Para preguntas sobre estos términos, contacta con hello@arbauto.eu.`,
  },
};

export default translations;
